import { ImageType } from "../enums";
import { Event } from "../interfaces";
import { isPreImage } from "./isPreImage";

export function getEventImageType(event: Event, isInternal: boolean): ImageType {
  if (isPreImage(event, isInternal)) {
    return ImageType.PreContext;
  }

  return ImageType.Context;
}
